import { useLocation, Navigate, Outlet } from 'react-router-dom';
import PropTypes from 'prop-types';

import useAuth from '@frolight/hooks/useAuth';

const RequireAuth = ({ allowedRoles }) => {
  const { auth } = useAuth();
  const location = useLocation();

  return (
    auth?.roles?.find(role => allowedRoles?.includes(role))
      ? <Outlet />
      : auth?.accessToken?.token
        ? <Navigate to="/unauthorized" state={{ from: location }} replace />
        : <Navigate to="/sign-in" state={{ from: location }} replace />
  );
};

RequireAuth.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default RequireAuth;
